import * as React from 'react';
const SvgQuestionnaire = (props) => (
  <svg viewBox="0 0 121 123" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#questionnaire_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="m109.107 67.712-4.564 4.512M109.107 111.232l-4.564-4.505M65.027 111.232l4.564-4.505M65.027 67.712l4.564 4.512M87.067 57.957v7.124M119.028 89.475h-7.217M55.106 89.475h7.217M87.067 72.016c-9.422 0-18.799 7.735-17.974 18.336.313 3.975 2.058 7.875 4.423 10.715 5.382 6.467 4.756 5.849 4.928 9.029H95.69c.167-3.18-.453-2.562 4.929-9.029 2.365-2.84 4.11-6.74 4.423-10.715.831-10.607-8.553-18.337-17.975-18.337ZM78.444 110.102v3.118c0 4.707 3.868 8.524 8.636 8.524 4.8 0 8.674-3.861 8.63-8.6l-.02-3.042M24.865 11.585H1.278v97.041h55.58M63.455 11.585h23.58l.032 39.4" />
      <path d="M56.321 7.736h-3.484c-1.08-3.736-4.55-6.474-8.68-6.474s-7.6 2.738-8.68 6.474h-3.484c-4.68 0-8.476 3.748-8.476 8.367v5.994H64.79v-5.994c0-4.619-3.797-8.367-8.476-8.367h.006ZM39.835 43.09h27.512M21.023 43.135l3.222 4.442 8.342-8.973M39.835 60.714h27.512M21.023 60.758l3.222 4.436 8.342-8.966M55.637 78.332H39.835M21.023 78.376l3.222 4.442 8.342-8.973" />
    </g>
    <defs>
      <clipPath id="questionnaire_svg__a">
        <path fill="#fff" d="M0 0h120.307v123H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQuestionnaire;
